import { type UseBreakpointProps } from '@hivebrite/design-system/Theme';

import {
  filtersNew,
  filtersOld,
} from 'hb-react/frontoffice/apps/NewsIndex/utils';
import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';

export const newsSearchFilters = ({
  breakpoint,
  flagEvNewsRevamp,
}: {
  breakpoint: UseBreakpointProps;
  flagEvNewsRevamp: boolean;
}) => ({
  ...BLOCKS.filters,
  attributes: {
    filters: flagEvNewsRevamp ? filtersNew : filtersOld,
  },
  templateAttributes: {
    [twoColumnsTemplate.id]: {
      filtersByRow: breakpoint === 'm' ? 3 : 1,
      filterRows: breakpoint === 'm' ? 1 : 3,
      actionButtonsCanOverflow: true,
    },
  },
});
